import create from "zustand";

const useActiveClientStore = create((set: any) => ({
    activeClient: {},
    setActiveClient: (data: any) => set(() => ({ activeClient: data })),
}));

export { useActiveClientStore };
